import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/mobile.css'
import * as echarts from 'echarts'
import moment from 'moment'
import 'moment/locale/zh-cn'
import VueClipboard from 'vue-clipboard2'
import request from './utils/request'

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$http = request
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

